import * as React from "react";
function MdIcon() {
    return React.createElement("path", { d: "M4.00002 17V9.89477H17V17H4.00002ZM5.14706 15.8158H15.853V11.079H5.14706V15.8158Z", fill: "currentColor" });
}
export default MdIcon;
//# sourceMappingURL=Md.js.map